<template>
    <div class="hero">
      <img src="https://takeaway-landing-pages.k.elnino-production.com/storage/resources/delco-landing/hero-svg.svg" alt="" class="hero-background">
        <div class="container">
            <div class="hero__content" :class="{'aus-em' : isAuEm}" data-aos="zoom-in" data-aos-delay="0" data-aos-offset="0">
                <h1 v-html="data.main"></h1>
                <h2 v-html="data.sub"></h2>
                <a :href="data.buttonUrl" id="first-apply" @click="addDataLayer()"><div class="custom-button custom-button--white">{{ data.buttonText }}</div></a>
            </div>
            <div class="hero__image">
                <img :src="data.image" alt="" data-aos="fade-up" data-aos-delay="0" data-aos-offset="0" width="376" height="564" />
            </div>
        </div>
    </div>
</template>
  
  <script>
  import Content from "../data/content";
  let lang = process.env.VUE_APP_LOCALITY;
  
  export default {
    data: function() {
          return {
            data: Content[lang].hero,
            showToggles: false,
            isAuEm: lang == 'pl_en' ? true : false
          }
    },
    methods: {
      async addDataLayer() {
      window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          "event": "apply_submit",
          "component_type": "button",
          "component_name": "apply now",
          "component_location": "Introduction section"
      });
    }
    }
  };
  </script>
  
  <style>
  /* Hero */

.hero {
  padding: 117px 16px 20px;
  background-color: #ff8000;
  /* background-image: url('../assets/img/hero-svg.svg'); */
  position: relative;
  z-index: 1;
}

.hero .container {
  max-width: 940px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  overflow: hidden;
}

.hero__content {
  width: calc(55%);
}

.hero__content h1 {
  font-size: 65px;
  font-family: 'jet-extrabold';
  color: white;
  line-height: 110%;
  margin-bottom: 25px;
}

.hero__content.aus-em h1 {
  font-size: 59px;
}

.hero__content.aus-em h2 {
  font-size: 22px;
}

.hero__content h2 {
  font-size: 28px;
  color: white;
  font-family: 'jet-extrabold';
  max-widtH: 391px;
}

.hero__image {
  widtH: calc(40%);
}

.hero__image img {
  border-radius: 30px 30px 0 0;
}

.main-body .container {
  max-widtH: 1021px;
  margin: 0 auto;
  padding-left: 16px;
  padding-right: 16px;
  overflow: hidden;
}

.header__nav {
  z-index: 2;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

@media only screen and (max-width: 768px) {
  .hero {
    padding: 63px 0 0;
  }
  .hero .container {
    display: block;
    padding: 0 18px;
  }
  .hero h1 {
    font-size: 35px;
    line-height: 110%;
    margin-bottom: 14px;
  }
  .hero__content {
    width: 100%;
    text-align: center;
    margin-bottom: 72px;
  }
  .hero__content h2 {
    font-size: 22px;
    line-height: 120%;
    margin-bottom: 30px;
    margin-left: auto;
    margin-right: auto;
  }
  .hero__image {
    widtH: 100%;
    max-widtH: 400px;
    margin: 0 auto;
  }
  .hero__content .custom-button {
    margin-left: auto;
  }
}
  </style>